/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { EmptyStakingListImage } from 'assets/components';
import { TransactionItemPlaceholder } from '../../../components/Placeholders';
import StakingItemLayout from './StakingItemLayout';
import { stakingTypes } from '../constants';

const StakingList = ({ list, type, isLoading }) => {
  const { t: translate } = useTranslation();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const sortedList = useMemo(
    () =>
      list.filter((item) => {
        if (type === stakingTypes.COMPLETED) {
          return item.state === stakingTypes.ENDED || item.state === type;
        }
        return item.state === type;
      }),
    [list, type]
  );

  const sortLabels = useMemo(
    () => [
      {
        id: 0,
        title: translate('coin_name_label'),
        withIcon: false,
        onClick: () => {},
        classes: 'col-2',
        isMobile: true,
        enabled: false,
      },
      {
        id: 1,
        title: translate('staking_amount_label'),
        onClick: () => {},
        withIcon: false,
        classes: 'col-3',
        isMobile: false,
        enabled: false,
      },
      {
        id: 2,
        title: translate('create_staking_apr_label'),
        onClick: () => {},
        withIcon: false,
        classes: 'col-2',
        isMobile: false,
        enabled: false,
      },
      {
        id: 3,
        title: translate('staking_duration_label'),
        onClick: () => {},
        withIcon: false,
        classes: 'col-4',
        isMobile: false,
        enabled: false,
      },
      {
        id: 4,
        title: translate('actions_label'),
        withIcon: false,
        isRight: true,
        classes: 'col-1',
        isMobile: false,
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const renderSortLabels = () => (
    <div className="d-none d-md-flex container-fluid p-0 mt-4">
      <div className="row w-100 m-auto">
        {sortLabels
          .filter((item) => !item.hidden)
          .map((item, index) => {
            const attribs = {};
            if (item.withIcon) {
              attribs.tabIndex = '0';
              attribs.role = 'button';
              attribs.onClick = item.onClick;
              attribs.onKeyDown = () => {};
            }

            return (
              <div
                className={`${item.classes ? item.classes : 'col'} ${index === 0 ? 'px-0' : ''} ${
                  index === sortLabels.length - 1 ? 'pe-0' : ''
                }`}
                key={item.id}>
                <span
                  key={item.id}
                  style={item.isRight ? { marginLeft: 'auto' } : {}}
                  className={`${
                    item?.enabled ? 'text-primary' : 'text-shadow'
                  } text-f6 text-start text-nowrap d-flex flex-even align-items-center position-relative ${
                    item.isRight ? 'justify-content-end' : ''
                  } ${item.classes}`}
                  // eslint-disable-next-line react/jsx-props-no-spreading
                  {...attribs}>
                  <span>
                    {item.withIcon ? (
                      <img
                        alt="sort"
                        src="./assets/images/sort.svg"
                        className="me-1"
                        style={{ width: '1rem', height: '1rem' }}
                      />
                    ) : null}
                    <span>{item.title}</span>
                  </span>
                </span>
              </div>
            );
          })}
      </div>
    </div>
  );

  const renderEmptyList = () => (
    <>
      {/* mobile layout */}
      <div
        className="w-100 h-auto d-flex d-md-none justify-content-start flex-column align-items-center"
        style={{ paddingTop: '4rem' }}>
        <p className="text-dard text-f4 mt-3">{translate('no_staking_yet_label')}</p>
        <p className="text-shadow text-f5 mt-2">{translate('start_staking_label')}</p>
      </div>

      {/* browser layout */}
      <div
        className="d-none d-md-flex w-100 h-100 justify-content-start flex-column align-items-center"
        style={{ paddingTop: '6rem' }}>
        <EmptyStakingListImage />
        <p className="text-dard text-f4 mt-3">{translate('no_staking_yet_label')}</p>
        <p className="text-shadow text-f5 mt-2">{translate('start_staking_label')}</p>
      </div>
    </>
  );

  const showSortLabelsAndList = sortedList?.length > 0;

  return (
    <>
      {showSortLabelsAndList && renderSortLabels()}
      {!isLoading &&
        showSortLabelsAndList &&
        sortedList.map((item) => <StakingItemLayout key={item.id} item={item} />)}
      {!isLoading && !showSortLabelsAndList && renderEmptyList()}
      {isLoading && (
        <div className="mt-3">
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
          <TransactionItemPlaceholder />
        </div>
      )}
    </>
  );
};

export default StakingList;

StakingList.propTypes = {
  list: PropTypes.array,
  type: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

StakingList.defaultProps = {
  list: [],
};
